export type TUploadType =
  | 'image'
  | 'video'
  | 'audio'
  | 'visualMedia'
  | 'AIVideoImage'

// Define audio MIME types as a const array
const AUDIO_MIME_TYPES = [
  'audio/mpeg',
  'audio/wav',
  'audio/x-wav',
  'audio/vnd.wave',
  'audio/mp3',
  'audio/x-m4a',
  'audio/webm',
  'audio/flac',
  'audio/x-flac',
  'audio/ogg',
  'audio/webm;codecs=opus'
] as const

const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/mpeg',
  'video/quicktime',
  'video/3gpp',
  'video/MP2T',
  'video/x-flv',
  'video/x-msvideo',
  'video/ogg',
  'application/x-troff-msvideo',
  'video/avi',
  'video/msvideo',
  'video/x-msvideo'
] as const

export const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/heic',
  'image/heif',
  'image/webp',
  'image/vnd.microsoft.icon',
  'image/x-icon'
] as const

export const AI_VIDEO_IMAGE_MIME_TYPES = [
  'image/png',
  'image/jpg',
  'image/webp',
  'image/jpeg'
] as const

// Derive the type from the array
export type TAudioMimeTypes = (typeof AUDIO_MIME_TYPES)[number]

export const UPLOAD_TYPES: Record<TUploadType, readonly string[]> = {
  image: IMAGE_MIME_TYPES,
  video: VIDEO_MIME_TYPES,
  audio: AUDIO_MIME_TYPES,
  visualMedia: [...IMAGE_MIME_TYPES, ...VIDEO_MIME_TYPES],
  AIVideoImage: AI_VIDEO_IMAGE_MIME_TYPES
}

export const IMAGE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'heic',
  'heif',
  'webp'
] as const
